import Icona from 'components/3catinfo/ui/Icona';
import { getTipusCanalDirecte } from 'utils/canals';
import __isUndefined from 'lodash/isUndefined';
import __isEmpty from 'lodash/isEmpty';
import styles from './iconaMedia.module.scss';

const getMediaType = (mediaValue) => {
    const mediaMap = {
        1: 'foto',
        2: 'audio',
        3: 'video',
        4: 'cap'
    };

    return mediaMap[mediaValue] || null;
};

const IconaMedia = (props) => {
    const { videos, canals_directes_embedats, audios, mediadestacat } = props;
    const mediaType = getMediaType(mediadestacat);
    const tipusDirecteEmbedat = getTipusCanalDirecte(canals_directes_embedats, canals_directes_embedats);
    const hasMediaVideo = (mediaType === 'video' && !__isEmpty(videos)) || tipusDirecteEmbedat === 'video';
    const hasMediaAudio = (mediaType === 'audio' && !__isEmpty(audios)) || tipusDirecteEmbedat === 'audio';

    if (!hasMediaVideo && !hasMediaAudio) return <></>;

    const iconType = hasMediaVideo ? 'play' : 'auriculars_ple';

    return (
        <div>
            <span className={styles.iconaWrapper}>
                <Icona icona={iconType} isBlanc={true} mida={20} />
            </span>
        </div>
    );
};

export default IconaMedia;
